/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_No_GroupInputs */

const vi_customer_no_group = /** @type {(inputs: Customer_No_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Không có nhóm --`)
};

/**

* @param {Customer_No_GroupInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_no_group = /** @type {((inputs?: Customer_No_GroupInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_No_GroupInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_no_group(inputs)
});